import Grid from "@material-ui/core/Grid";
import TableCell from "@material-ui/core/TableCell";
import { createStyles, makeStyles } from "@material-ui/styles";
import React, { FC, useContext } from "react";
import { ExamDayType } from "../../model/ExamDayType";
import { ExamSessionCandidateExamState } from "../../model/examSessionCandidate/ExamSessionCandidateExamViewModel";
import { RoomViewModel } from "../../model/RoomViewModel";
import FormGridCell from "../common/FormGridCell";
import ExamSelect from "../examSession/ExamSelect";
import { SchedulerCandidateContextValue } from "./context/SchedulerCandidateContext";
import { SchedulerContextValue } from "./context/SchedulerContext";
import { isOralDay } from "./context/SchedulerContextUtils";
import SchedulerCandidateSelect from "./SchedulerCandidateSelect";
import SchedulerCaseNameTextField from "./SchedulerCaseNameTextField";

const useStyles = makeStyles(() =>
  createStyles({
    infoRow: {
      marginTop: 10,
    },
  })
);

export interface SchedulerCellProps {
  examIds: string[];
  room: RoomViewModel;
  timeSlotIndex: number;
}

const SchedulerCell: FC<SchedulerCellProps> = ({ examIds, room, timeSlotIndex }) => {
  const classes = useStyles();
  const {
    examTypes,
    readonly,
    isSessionPublished,
    selectedExamDayId,
    exams,
    examDays,
    addTimeSlotExam,
    removeTimeSlotExam,
    clearTimeSlotExams,
  } = useContext(SchedulerContextValue);
  const { schedulerExamCandidates } = useContext(SchedulerCandidateContextValue);
  const selectedDay = examDays.find((examDay) => examDay.id === selectedExamDayId);
  const isCorrectionDay = selectedDay?.type === ExamDayType.Correction;

  const selectedCandidates = schedulerExamCandidates.filter(
    (schedulerExamCandidate) =>
      schedulerExamCandidate.examDayId === selectedExamDayId &&
      schedulerExamCandidate.roomId === room.id &&
      schedulerExamCandidate.timeSlotIndex === timeSlotIndex &&
      schedulerExamCandidate.examState !== ExamSessionCandidateExamState.Cancelled
  );

  const handleAddExam = (examId: string) => {
    addTimeSlotExam(room.id, examId, timeSlotIndex);
  };

  const handleRemoveExam = (examId: string) => {
    removeTimeSlotExam(room.id, examId, timeSlotIndex);
  };

  const handleClearExams = () => {
    clearTimeSlotExams(room.id, timeSlotIndex);
  };

  return (
    <TableCell>
      <Grid container>
        <FormGridCell size="wide">
          <ExamSelect
            readonly={readonly || isSessionPublished}
            exams={exams}
            selectedExamIds={examIds}
            isMulti={isCorrectionDay}
            add={handleAddExam}
            remove={handleRemoveExam}
            clear={handleClearExams}
          />
        </FormGridCell>
        {isSessionPublished && !isCorrectionDay && examIds.length > 0 && (
          <FormGridCell size="wide" className={readonly ? classes.infoRow : ""}>
            <SchedulerCandidateSelect
              selectedCandidates={selectedCandidates}
              examId={examIds[0]}
              room={room}
              timeSlotIndex={timeSlotIndex}
            />
          </FormGridCell>
        )}
        {isOralDay(examTypes) && selectedCandidates.length === 1 && examIds.length > 0 && (
          <FormGridCell size="wide" className={classes.infoRow}>
            <SchedulerCaseNameTextField candidateId={selectedCandidates[0].candidateId} examId={examIds[0]} />
          </FormGridCell>
        )}
      </Grid>
    </TableCell>
  );
};

export default SchedulerCell;
